import { useQuery } from "@tanstack/react-query"

import { api } from "@/api"
import { ENDPOINTS } from "@/constants"
import type {
  TransactionsResponseType,
  TransactionsSearchParams,
} from "@/types/transactions"
import { StringHelper } from "@/utils"
export const transactions = async (params: TransactionsSearchParams) => {
  const queryString = StringHelper.objectToQueryString(params)
  const url = `${ENDPOINTS.TRANSACTION}?${queryString}`
  const { data } = await api.get<TransactionsResponseType>(url)
  return data
}
const useTransactions = (params: TransactionsSearchParams, enabled = false) =>
  useQuery({
    queryKey: [ENDPOINTS.TRANSACTION, params],
    queryFn: () => transactions(params),
    enabled,
  })
export default useTransactions
